"use client";

import { useEffect, useState } from "react";

type Category = { id: number; name: string; sort_order: number };
type Document = { id: number; title: string; category_id: number; category_name: string };

export function DriveAdminPanel() {
  const [categories, setCategories] = useState<Category[]>([]);
  const [documents, setDocuments] = useState<Document[]>([]);
  const [message, setMessage] = useState("");

  const load = async () => {
    const response = await fetch("/api/drive", { cache: "no-store" });
    const payload = await response.json() as { categories?: Category[]; documents?: Document[] };
    setCategories(payload.categories ?? []);
    setDocuments(payload.documents ?? []);
  };
  useEffect(() => { void load(); }, []);

  const persistCategory = async (category: Category) => {
    await fetch("/api/drive", { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ type: "category", id: category.id, name: category.name, sortOrder: category.sort_order }) });
  };
  const updateCategory = async (category: Category) => {
    await persistCategory(category);
    setMessage("Organisation enregistrée.");
    await load();
  };
  const move = async (index: number, delta: number) => {
    const otherIndex = index + delta;
    if (!categories[otherIndex]) return;
    const current = { ...categories[index], sort_order: categories[otherIndex].sort_order };
    const other = { ...categories[otherIndex], sort_order: categories[index].sort_order };
    await Promise.all([persistCategory(current), persistCategory(other)]);
    setMessage("Ordre des catégories enregistré.");
    await load();
  };
  const removeCategory = async (id: number) => {
    const response = await fetch(`/api/drive?type=category&id=${id}`, { method: "DELETE" });
    const payload = await response.json() as { error?: string };
    setMessage(response.ok ? "Catégorie supprimée." : payload.error || "Suppression impossible.");
    await load();
  };
  const moveDocument = async (document: Document, categoryId: number) => {
    await fetch("/api/drive", { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ type: "document", id: document.id, title: document.title, categoryId }) });
    setMessage("Document déplacé.");
    await load();
  };
  const removeDocument = async (id: number) => {
    if (!window.confirm("Supprimer ce document et son fichier ?")) return;
    await fetch(`/api/drive?type=document&id=${id}`, { method: "DELETE" });
    setMessage("Document supprimé.");
    await load();
  };

  return (
    <section className="admin-content-card drive-admin">
      <header><div><span>DOCUMENTATION ÉQUIPE</span><h1>Organisation du Drive</h1><p>Réordonnez les catégories, renommez-les et déplacez les documents.</p></div><a href="/?tool=drive">Ouvrir le Drive →</a></header>
      {message && <div className="drive-admin-message">{message}</div>}
      <div className="drive-admin-layout">
        <section><h2>Catégories</h2><div className="drive-admin-categories">{categories.map((category, index) => <article key={category.id}><span>{index + 1}</span><input value={category.name} onChange={(event) => setCategories((current) => current.map((item) => item.id === category.id ? { ...item, name: event.target.value } : item))} /><b>{documents.filter((document) => document.category_id === category.id).length} doc.</b><button type="button" onClick={() => void move(index, -1)}>↑</button><button type="button" onClick={() => void move(index, 1)}>↓</button><button type="button" onClick={() => void updateCategory(category)}>Sauver</button><button type="button" className="danger" onClick={() => void removeCategory(category.id)}>×</button></article>)}</div></section>
        <section><h2>Documents</h2><div className="drive-admin-documents">{documents.map((document) => <article key={document.id}><span>📄</span><div><strong>{document.title}</strong><small>{document.category_name}</small></div><select value={document.category_id} onChange={(event) => void moveDocument(document, Number(event.target.value))}>{categories.map((category) => <option key={category.id} value={category.id}>{category.name}</option>)}</select><button type="button" onClick={() => void removeDocument(document.id)}>Supprimer</button></article>)}</div></section>
      </div>
    </section>
  );
}
